import { z } from 'zod/v4'
import createComponentSchema from '../util/createComponentSchema'

const LanguageSchema = z.object({
  lang: z.string(),
  label: z.string(),
  href: z.string()
})

const ResponsiveImageObjectSchema = z.union([
  z.object({
    desktop: z.object({
      src: z.string(),
      alt: z.string()
    })
  }),
  z.object({
    mobile: z.object({
      src: z.string(),
      alt: z.string()
    })
  })
])

const MenuSchema = z.object({
  des: z.string(),
  url: z
    .array(z.object({ des: z.string(), complement: z.string() }))
    .optional(),
  /* @deprecated */
  filteraction: z.string().optional()
})

const PositionSchema = z.object({
  order: z.number().optional(),
  align: z.enum(['left', 'right']).optional(),
  representation: z.enum([
    'logo_area',
    'icon',
    'des',
    'action_button',
    'component',
    'link',
    'breadcrumbs',
    'navigation_menu',
    'management_dashboard'
  ]),
  des: z.string().optional(),
  image: z.union([z.string(), ResponsiveImageObjectSchema]).optional(),
  alt: z.string().optional(),
  link: z.string().optional(),
  component: z.string().optional(),
  routes: z
    .array(
      z.object({
        des: z.string(),
        link: z.string()
      })
    )
    .optional(),
  menus: z.array(MenuSchema).optional(),
  components: z
    .array(
      z.object({
        uuid: z.string(),
        des: z.string(),
        menus: z.array(MenuSchema).optional(),
        is_private: z.boolean().optional(),
        align: z.enum(['left', 'right']).optional()
      })
    )
    .optional()
})

const TopLineSchema = createComponentSchema(
  'TopLine',
  z.object({
    layout: z
      .union([
        z.object({
          position_1: z.array(PositionSchema).optional(),
          position_2: z.array(PositionSchema).optional(),
          position_3: z.array(PositionSchema).optional()
        }),
        z.string()
      ])
      .optional(),
    placement: z
      .enum([
        'default',
        'fixed-top',
        'fixed-bottom',
        'sticky-top',
        'sticky-bottom'
      ])
      .optional(),
    available_languages: z.array(LanguageSchema).optional()
  })
)

export default TopLineSchema
